/**
 * Notification Provider Component
 * Displays toast notifications using Material-UI Snackbar
 */

import { Snackbar, Alert, AlertColor } from '@mui/material';
import { useNotificationStore } from '../store/notificationStore';

export default function NotificationProvider() {
  const notifications = useNotificationStore((state) => state.notifications);
  const removeNotification = useNotificationStore((state) => state.removeNotification);

  // Only show the most recent notification
  const currentNotification = notifications[notifications.length - 1];

  if (!currentNotification) {
    return null;
  }

  const handleClose = () => {
    removeNotification(currentNotification.id);
  };

  return (
    <Snackbar
      open={true}
      autoHideDuration={currentNotification.duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={currentNotification.type as AlertColor}
        variant="standard"
        sx={{ width: '100%' }}
      >
        {currentNotification.message}
      </Alert>
    </Snackbar>
  );
}
